// extracted by mini-css-extract-plugin
export default {"button":"LoginLink_button__ATvzR","labelSize":"LoginLink_labelSize__bmojc"};